import React from "react";
import { Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

import { InitiativeDetailTimelineIcon } from "assets";
import { FieldLabel } from "pages/authenticated/accelerate/initiatives-management/components";
import { SectionCard } from "../section-card";
import { detailInputSx } from "../../styles";
import { TimelineSectionProps } from "./types";
import { TIMELINE_TOOLTIP } from "./consts";

export const TimelineSection: React.FC<TimelineSectionProps> = ({
  form,
  updateField,
}) => (
  <SectionCard
    tooltip={TIMELINE_TOOLTIP}
    title="Timeline"
    icon={<InitiativeDetailTimelineIcon width={36} height={36} />}
  >
    <Box sx={{ display: "flex", gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <FieldLabel>Start Date</FieldLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD/MM/YYYY"
            value={form.startDate ? dayjs(form.startDate) : null}
            onChange={(d: Dayjs | null) =>
              updateField("startDate", d ? d.format("YYYY-MM-DD") : "")
            }
            slotProps={{
              textField: { size: "small", fullWidth: true, sx: detailInputSx },
            }}
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ flex: 1 }}>
        <FieldLabel>End Date</FieldLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD/MM/YYYY"
            value={form.endDate ? dayjs(form.endDate) : null}
            onChange={(d: Dayjs | null) =>
              updateField("endDate", d ? d.format("YYYY-MM-DD") : "")
            }
            slotProps={{
              textField: { size: "small", fullWidth: true, sx: detailInputSx },
            }}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  </SectionCard>
);
